import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Model, ModelQueryParams } from "../types";
import { COMMON_STATUS } from "constants/constants";
import { languages } from "constants/constants";

interface ModelState {
	models: Array<Model>;
	modelsTotal: number;
	model: Model;
}

export const modelDefault: Model = {
	name: "",
	brand: undefined,
	status: COMMON_STATUS.enabled.value,
	manufactureYears: [],
	translation: languages.reduce((newObj: any, el) => {
		newObj[el.key] = "";
		return newObj;
	}, {}),
};

const initialState: ModelState = {
	models: [],
	modelsTotal: 0,
	model: modelDefault,
};

export const modelSlice = createSlice({
	name: "model",
	initialState,
	reducers: {
		setModels: (state, action) => {
			state.models = action.payload.data;
			state.modelsTotal = action.payload.total;
		},
		setModel: (state, action) => {
			state.model = action.payload;
		},
		changeStatusModel: (state, action) => {
			const { id, status } = action.payload;
			const index = state.models.findIndex(el => el.id === id);
			state.models[index].status = status;
		},
	},
});

export const selectModels = (state: RootState) => state.model.models;
export const selectModelsTotal = (state: RootState) => state.model.modelsTotal;
export const selectModel = (state: RootState) => state.model.model;

export const { setModels, setModel, changeStatusModel } = modelSlice.actions;

export interface GetModelsAsyncPayload {
	query: ModelQueryParams;
	callback?: () => void;
}

export interface GetModelDetailPayload {
	id: string | number;
}
export interface CreateModelPayload {
	data: Model;
	callback: () => void;
}
export interface UpdateModelPayload {
	id: number | string;
	data: Model;
	callback?: () => void;
}

export const getModelsAsync = createAction(
	"model/getModels",
	(payload: GetModelsAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getModelDetailAsync = createAction(
	"const/getModelDetailAsync",
	(payload: GetModelDetailPayload) => ({
		payload: payload,
	}),
);

export const createNewModelAsync = createAction(
	"model/createNewModel",
	(payload: CreateModelPayload) => ({
		payload: payload,
	}),
);

export const updateModelAsync = createAction(
	"model/updateModel",
	(payload: UpdateModelPayload) => ({
		payload: payload,
	}),
);

export default modelSlice.reducer;
